var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-panel',[_c('el-table-wrapper',{ref:"targetTestDeviceList",staticStyle:{"width":"100%"},attrs:{"slot":"body","show-custom-header":false,"data":_vm.dataList,"columns":_vm.deviceColumns,"column-default":_vm.columnDefault},on:{"selection-change":_vm.targetChangeSelection},slot:"body"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb4f024e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/netdevice/ScriptSettings/component/TargetTestDeviceList.vue
// module id = null
// module chunks = 